import type { SDKOptions, MapProvider } from "~/types/options";
import type { POI, School, Schools, POICategories } from "@local-logic/client";

export type Options = {
  lat?: number;
  lng?: number;
  geographyId?: string;
  zoom?: number;
  pitch?: number;
  bearing?: number;
  distanceUnit?: "metric" | "imperial";
  cooperativeGestures?: boolean;
  mapProvider?: MapProvider;
  hideAttribution?: boolean;
};

export type NeighborhoodMapProps = SDKOptions<
  Options,
  {
    options: Options | undefined;
  }
>;

export type POICategory =
  | "restaurants"
  | "groceries"
  | "shopping"
  | "nightlife"
  | "cafes"
  | "daycares"
  | "busStops"
  | "metroStations"
  | "trainStations"
  | "parks"
  | "fitness"
  | "medical"
  | "petCare"
  | "fuelStations"
  | "activities"
  | "homeImprovement"
  | "personalCare"
  | "schools";
export type POIGroup = (keyof typeof POICategories)[];
export type SchoolGroup = (keyof Schools)[];
export type Marker = POI | School;

export enum TrackingPipelineEvents {
  SDK_VIEWED = "neighborhood-map-Viewed",
  CATEGORY_CLICKED = "neighborhood-map-Category-Clicked",
  POI_CLICKED = "neighborhood-map-Poi-Clicked",
  POI_LINK_CLICKED = "neighborhood-map-Poi-Link-Clicked",
  SEARCH_RADIUS_CHANGED = "neighborhood-map-Search-Radius-Changed",
}

// Why are these named differently?
// https://docs.mixpanel.com/docs/data-structure/events-and-properties#name-events-and-properties-consistently
export enum AnalyticsEvents {
  SDK_VIEWED = "sdk_viewed",
  CATEGORY_CLICKED = "category_clicked",
  POI_CLICKED = "poi_clicked",
  POI_LINK_CLICKED = "poi_link_clicked",
  SEARCH_RADIUS_CHANGED = "search_radius_changed",
}
